export default function ImpressumPage() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8] min-h-screen" data-testid="impressum-page">
      <section className="py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <h1 className="font-serif text-3xl md:text-4xl font-medium text-[#2C332E] mb-8">
            Impressum
          </h1>
          
          <div className="prose prose-lg text-[#6B7280] space-y-8">
            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <p>
                Nedzmija Rosic<br />
                Herderstr. 6<br />
                85435 Erding<br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                Kontakt
              </h2>
              <p>
                E-Mail: <a href="mailto:kontakt@eidgeschenke.de" className="text-[#4A5D4F] hover:underline">kontakt@eidgeschenke.de</a>
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV
              </h2>
              <p>
                Nedzmija Rosic<br />
                Herderstr. 6<br />
                85435 Erding
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                Haftungsausschluss
              </h2>
              <h3 className="font-medium text-[#2C332E] mb-2">Haftung für Inhalte</h3>
              <p className="text-sm">
                Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. 
                Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte 
                können wir jedoch keine Gewähr übernehmen.
              </p>
              
              <h3 className="font-medium text-[#2C332E] mt-4 mb-2">Haftung für Links</h3>
              <p className="text-sm">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren 
                Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden 
                Inhalte auch keine Gewähr übernehmen.
              </p>
            </section>

            <section>
              <h2 className="font-serif text-xl font-medium text-[#2C332E] mb-4">
                Affiliate-Hinweis
              </h2>
              <p className="text-sm">
                Einige Links sind Partnerlinks. Wenn du darüber kaufst, erhalten 
                wir eine kleine Provision. Für dich entstehen dadurch keine Mehrkosten.
              </p>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
}
